import React from 'react';
import { Routes, Route, Navigate } from 'react-router-dom';
import App from './App';
import SEOLandingPage from './SEOLandingPage';
import StaticPage from './StaticPage';

const staticPageRoutes = [
  'about-us',
  'help-center',
  'safety',
  'contact-us',
  'terms-of-service',
  'privacy-policy',
  'cookie-policy',
  'sitemap'
];

const seoRoutePatterns = [
  '/rent/:propertyType/:city',
  '/rent/:propertyType/:city/:area',
  '/rent/:propertyType/:city/:bedroomSlug',
  '/rent/:propertyType/:city/:area/:bedroomSlug'
];

function AppRouter() {
  return (
    <Routes>
      <Route path="/" element={<App />} />
      <Route path="/about-us" element={<StaticPage pageKey="about-us" />} />
      <Route path="/help-center" element={<StaticPage pageKey="help-center" />} />
      <Route path="/safety" element={<StaticPage pageKey="safety" />} />
      <Route path="/contact-us" element={<StaticPage pageKey="contact-us" />} />
      <Route path="/terms-of-service" element={<StaticPage pageKey="terms-of-service" />} />
      <Route path="/privacy-policy" element={<StaticPage pageKey="privacy-policy" />} />
      <Route path="/cookie-policy" element={<StaticPage pageKey="cookie-policy" />} />
      <Route path="/sitemap" element={<StaticPage pageKey="sitemap" />} />
      <Route path="/rent/:propertyType/:city" element={<SEOLandingPage />} />
      <Route path="/rent/:propertyType/:city/:bedroomSlug" element={<SEOLandingPage />} />
      <Route path="/rent/:propertyType/:city/:area/:bedroomSlug" element={<SEOLandingPage />} />
      <Route path="/rent/:propertyType/:city/:area" element={<SEOLandingPage />} />
      {seoRoutePatterns.map((path) => (
        <Route key={`${path}-property`} path={`${path}/property/:id`} element={<SEOLandingPage />} />
      ))}
      {seoRoutePatterns.map((path) => (
        <Route key={`${path}-signin`} path={`${path}/signin`} element={<SEOLandingPage />} />
      ))}
      {seoRoutePatterns.map((path) => (
        <Route key={`${path}-signup`} path={`${path}/signup`} element={<SEOLandingPage />} />
      ))}
      {seoRoutePatterns.map((path) => (
        <Route key={`${path}-profile`} path={`${path}/profile`} element={<SEOLandingPage />} />
      ))}
      {seoRoutePatterns.map((path) => (
        <Route key={`${path}-listings`} path={`${path}/listings`} element={<SEOLandingPage />} />
      ))}
      {seoRoutePatterns.map((path) => (
        <Route key={`${path}-chats`} path={`${path}/chats`} element={<SEOLandingPage />} />
      ))}
      {seoRoutePatterns.map((path) => (
        <Route key={`${path}-settings`} path={`${path}/settings`} element={<SEOLandingPage />} />
      ))}
      <Route path="/property/:id" element={<App />} />
      <Route path="/profile" element={<App />} />
      <Route path="/listings" element={<App />} />
      <Route path="/chats" element={<App />} />
      <Route path="/settings" element={<App />} />
      <Route path="/analytics" element={<App />} />
      <Route path="/signin" element={<App />} />
      <Route path="/signup" element={<App />} />
      {staticPageRoutes.map((pageKey) => (
        <Route key={`${pageKey}-signin`} path={`/${pageKey}/signin`} element={<StaticPage pageKey={pageKey} />} />
      ))}
      {staticPageRoutes.map((pageKey) => (
        <Route key={`${pageKey}-signup`} path={`/${pageKey}/signup`} element={<StaticPage pageKey={pageKey} />} />
      ))}
      {staticPageRoutes.map((pageKey) => (
        <Route key={`${pageKey}-profile`} path={`/${pageKey}/profile`} element={<StaticPage pageKey={pageKey} />} />
      ))}
      {staticPageRoutes.map((pageKey) => (
        <Route key={`${pageKey}-listings`} path={`/${pageKey}/listings`} element={<StaticPage pageKey={pageKey} />} />
      ))}
      {staticPageRoutes.map((pageKey) => (
        <Route key={`${pageKey}-chats`} path={`/${pageKey}/chats`} element={<StaticPage pageKey={pageKey} />} />
      ))}
      {staticPageRoutes.map((pageKey) => (
        <Route key={`${pageKey}-settings`} path={`/${pageKey}/settings`} element={<StaticPage pageKey={pageKey} />} />
      ))}
      <Route path="*" element={<Navigate to="/" replace />} />
    </Routes>
  );
}

export default AppRouter;
